export const getFormDataWithLabelAsField = (
  fields: any[],
  formData: Record<string, any>,
  locationData: any
): Record<string, any> => {
  if (!fields?.length || !formData) return {};

  const fieldMap = new Map(fields.map((f) => [String(f.id), f]));
  const result: Record<string, any> = {};

  Object.entries(formData).forEach(([key, value]) => {
    const field = fieldMap.get(key);
    if (!field) return;

    // Handle country type - flatten and get names from locationData
    if (field.type === "country" && typeof value === "object") {
      console.log("Value: ", value);
      const country = locationData?.countries?.find(
        (c: any) => c.id == value.country
      );
      result["Country"] = country?.name || value.country || "";
      const state = locationData?.states?.find((s: any) => s.id == value.state);
      result["State"] = state?.name || value.state || "";
      const city = locationData?.cities?.find((c: any) => c.id == value.city);
      result["City"] = city?.name || value.city || "";
      const district = locationData?.districts?.find(
        (d: any) => d.id == value.district
      );
      result["District"] = district?.name || value.district || "";
    } else {
      result[field.label] = value;
    }
  });

  return result;
};
